<template>
    <div>
        <van-nav-bar title="GXPAY  数字货币交易" left-text="返回" left-arrow @click-left="$router.push('/member/members')" />
        <van-row>
        <van-col span="8">
          <div class="capital">
            <h5>Gxpay 余额</h5>
            <p>{{ gxpay_balance }}GCNY</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>冻结资金</h5>
            <p>{{ gxpay_frozen_balance }}GCNY</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>GCNY:元=1:1</h5>
          </div>
        </van-col>
      </van-row>

        <van-row>
        <van-col span="8">
          <div class="capital">
             <van-button
              round
              class="button-in"
              type="danger"
              size="normal"
              @click="gxpayBuy()"
              style="height: 30px; width: 100px"
              >买币</van-button
            >
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
           <van-button
              round
              class="button-out"
              type="danger"
              size="normal"
              @click="gxpaySell()"
              style="height: 30px; width: 100px"
              >卖币</van-button
            >
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
           <van-button
              round
              class="button-in"
              type="danger"
              size="normal"
              @click="gxpayOrderList()"
              style="height: 30px; width: 100px"
              >我的订单</van-button
            >
          </div>
        </van-col>
      </van-row>
        <!-- <van-cell-group id="vancellColor"> -->
            <!-- <van-cell title="Gxpay 账号" :value="gxpay_account"></van-cell>
            <van-cell title="Gxpay ID" :value="gxpay_id"></van-cell>
            <van-cell title="Gxpay 余额" :value="gxpay_balance"></van-cell>
            <van-cell title="冻结资金" :value="gxpay_frozen_balance"></van-cell>
            <van-cell title="买币" is-link @click="gxpayBuy()"/>
            <van-cell title="卖币" is-link @click="gxpaySell()"/>
            <van-cell title="我的订单" is-link @click="gxpayOrderList()"/> -->
            <van-cell center><div v-html="gxpayContentDescription"></div></van-cell>
        <!-- </van-cell-group> -->
    </div>
</template>

<script>
export default {
    name: "Gxpay",
    data() {
        return {
            gxpay_account: 0,
            gxpay_id: 0,
            gxpay_balance: 0,
            gxpay_frozen_balance: 0,
            buyUrl:'',
            sellUrl:'',
            orderListUrl:'',
            gxpayContentDescription:''
        }
    },
    computed: {
    },
    methods: {
        isLogin() {
            let that = this;
            if (!that.$store.state.loginType) {
                that.$router.push('/login')
            }
        },
        getGxpayDigitalCurrency(){
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                    nozzle: "gxpay_thirdparty_digital_currency",
                    token: sessionStorage.getItem("token")
                }
            })
            .then(function(res) {
                if (res.data.code == 1) {
                    let resData = res.data;
                    that.gxpay_account = resData.data.account;
                    that.gxpay_id = resData.data.numberId;
                    that.gxpay_balance = resData.data.walletDTOList.length>0?resData.data.walletDTOList[0]['money']:0;
                    that.gxpay_frozen_balance = resData.data.walletDTOList.length>0?resData.data.walletDTOList[0]['frozenMoney']:0;
                    that.buyUrl = resData.data.buyUrl
                    that.sellUrl = resData.data.sellUrl
                    that.orderListUrl = resData.data.orderListUrl
                    that.gxpayContentDescription=resData.data.gxpay_description
                } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(res.data.msg);
                }
            });
        },
        gxpayBuy(){
            window.open(this.buyUrl, "_blank");
        },
        gxpaySell(){
            window.open(this.sellUrl, "_blank");
        },
        gxpayOrderList(){
            window.open(this.orderListUrl, "_blank");
        },
        // gxpayContentDesc() {
        //     let that = this;
        //     that
        //         .$http({
        //         url: "/",
        //         method: "post",
        //         data: {
        //             nozzle: "sysconfig",
        //             token: sessionStorage.getItem("token"),
        //             name: "gxpay_desc",
        //         },
        //         })
        //         .then(function (res) {
        //         if (res.data.code == 1) {
        //             that.gxpayContentDescription = res.data.data;
        //         } else if (res.data.code === 0 || res.data.code === -1) {
        //             that.$toast.fail(res.data.msg);
        //         }
        //         });
        // },
    },
    mounted: function () {
        this.isLogin();
        this.getGxpayDigitalCurrency();
        // this.gxpayContentDesc();
    }
}
</script>

<style scoped>
.navStyles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}
</style>
<style>
.capital {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  color: #000000;
  margin-bottom:5px;
}

.capital p {
  margin: 0;
  color: #D02E27;
  font-size: 14px;
  font-weight: bold;
}

#vancellColor .van-cell__value{
    color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Gxpay.vue